import Finder from "../components/Finder";


const StandaloneFinder = () => {
    return <Finder />;
};
export default StandaloneFinder;